<template>
  <div class="" v-if="mode === 'light'">
    <div v-show="logo" class="absolute logo-pos-2 flex items-center cursor-pointer" @click="$router.push('/');">
      <img src="../assets/icons/logo.svg" class=" cursor-pointer" alt="logo">
      <!-- <img src="../assets/home/glsl-js.svg" class="ml-5 hidden xl:block" alt="glsl and js academy"> -->
    </div>

    <!-- <div class="absolute login-pos-2" v-if="!isAtAuth">
      <img src="../assets/home/login.svg" class="cursor-pointer" alt="login" @click="$router.push('/login')">
    </div> -->
    <div class="absolute top-0 right-0 mt-8 mr-8 lg:hidden" v-if="logo" @click="menu = true">
      Menu
    </div>

    <div class="fixed top-0 left-0 w-full h-full bg-blue-600 flex-col justify-around items-around lg:hidden" v-if="menu">
      <div class="absolute top-0 right-0 mt-8 mr-8" @click="menu = false">
        Close
      </div>
      <div class="h-16"></div>
      <router-link exact-active-class="underline" @click="menu = false" class=" inline-flex px-8 my-8 w-full justify-center" to="/"><div class="px-4 hover:underline cursor-pointer inline-block">Home</div></router-link>
      <router-link exact-active-class="underline" @click="menu = false" class=" inline-flex px-8 my-8 w-full justify-center" to="/about"><div class="px-4 hover:underline cursor-pointer inline-block">About</div></router-link>
      <router-link exact-active-class="underline" @click="menu = false" class=" inline-flex px-8 my-8 w-full justify-center" to="/team"><div class="px-4 hover:underline cursor-pointer inline-block">Team</div></router-link>
      <router-link exact-active-class="underline" @click="menu = false" class=" inline-flex px-8 my-8 w-full justify-center" to="/lab"><div class="px-4 hover:underline cursor-pointer inline-block">Lab</div></router-link>
      <router-link exact-active-class="underline" @click="menu = false" class=" inline-flex px-8 my-8 w-full justify-center" to="/contact"><div class="px-4 hover:underline cursor-pointer inline-block">Contact</div></router-link>
    </div>

    <div class="hidden lg:block absolute top-0 right-0 m-8 text-white">
      <router-link to="/"><div class="px-4 hover:underline cursor-pointer inline-block">Home</div></router-link>
      <router-link to="/about"><div class="px-4 hover:underline cursor-pointer inline-block">About</div></router-link>
      <router-link to="/team"><div class="px-4 hover:underline cursor-pointer inline-block">Team</div></router-link>
      <router-link to="/lab"><div class="px-4 hover:underline cursor-pointer inline-block">Lab</div></router-link>
      <router-link to="/contact"><div class="px-4 pr-0 hover:underline cursor-pointer inline-block">Contact</div></router-link>
    </div>

    <!-- <div class="absolute login-pos-3" v-if="home">
      <router-link to="/">
        <img class="jelly-button" src="../assets/home/jelly-button-white.svg" alt="Jelly Button">
        <div class=" flex justify-center  tracking-widest">
          Home
        </div>
      </router-link>
    </div> -->

    <div :style="{ height: taller }"></div>

  </div>
  <div class="" v-else-if="mode === 'dark'">
    <div v-show="logo" class="absolute logo-pos-2 flex items-center cursor-pointer" @click="$router.push('/');">
      <img src="../assets/icons/logo-dark.svg" class=" cursor-pointer" alt="logo">
      <!-- <img src="../assets/home/glsl-js-dark.svg" class="ml-5 hidden xl:block" alt="glsl and js academy"> -->
    </div>

    <!-- <div class="absolute login-pos-2" v-if="!isAtAuth">
      <img src="../assets/home/login-dark.svg" class="cursor-pointer" alt="login" @click="$router.push('/login')">
    </div> -->

    <div class="absolute login-pos-2" v-if="home">
      <router-link to="/">
        <img class="jelly-button" src="../assets/home/jelly-button-blue.svg" alt="Jelly Button">
        <div class=" flex justify-center  tracking-widest">
          Home
        </div>
      </router-link>
    </div>

    <div :style="{ height: taller }"></div>
  </div>
</template>

<script>
export default {
  props: {
    logo: {
      default: true
    },
    home: {
      default: false
    },
    mode: {
      default: 'dark'
    },
    taller: {
      default: '110px'
    }
  },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    isAtAuth () {
      return this.$route.path === '/login' || this.$route.path === '/register'
    }
  }
}
</script>

<style lang="postcss" scoped>
.logo-pos-2{
  top: 40px;
  left: 35px;
}

.login-pos-3{
  top: 70px;
  left: 35px;
}

.taller{
  height: 110px;
}

.jelly-button{
  cursor: pointer;
  display: block;
  width: 90px;
}
</style>
